import { Users } from 'lucide-react';

const initials = name =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');

export const PlayersCard = ({ players }) => (
  <div className="card border border-white/10 bg-base-200/20">
    <div className="card-body gap-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold">
            <Users className="h-4 w-4 text-primary" />
            Players online
          </div>
          <div className="mt-1 text-xs text-base-content/65">Live list of connected players.</div>
        </div>
        <div className="badge badge-outline border-white/10 text-xs">{players.length} active</div>
      </div>

      <div className="grid gap-2">
        {players.map(player => (
          <div
            key={player.id}
            className="flex items-center gap-3 rounded-2xl border border-white/10 bg-base-300/10 px-3 py-2"
          >
            <div className="grid h-10 w-10 place-items-center rounded-2xl bg-primary/15 text-sm font-semibold text-primary">
              {initials(player.name)}
            </div>
            <div className="min-w-0 text-sm font-semibold">{player.name}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
